import { render, staticRenderFns } from "./teams-card-big.vue?vue&type=template&id=7d547229&scoped=true&"
import script from "./teams-card-big.vue?vue&type=script&lang=js&"
export * from "./teams-card-big.vue?vue&type=script&lang=js&"
import style0 from "./teams-card-big.vue?vue&type=style&index=0&id=7d547229&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d547229",
  null
  
)

export default component.exports